import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("i", { class: "fa fa-list p-mr-2" }, null, -1)
const _hoisted_2 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_3 = { class: "p-field p-col-12 p-lg-3" }
const _hoisted_4 = { class: "p-field p-col-12 p-lg-3" }
const _hoisted_5 = { class: "p-float-label" }
const _hoisted_6 = { class: "kn-material-input-label" }
const _hoisted_7 = { class: "p-field p-col-12 p-lg-3" }
const _hoisted_8 = { class: "p-float-label" }
const _hoisted_9 = { class: "kn-material-input-label" }
const _hoisted_10 = { class: "p-field p-col-12 p-lg-3" }
const _hoisted_11 = { class: "p-float-label" }
const _hoisted_12 = { class: "kn-material-input-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_HierarchyManagementHierarchiesFilterCard = _resolveComponent("HierarchyManagementHierarchiesFilterCard")
  const _component_HierarchyManagementHierarchiesTree = _resolveComponent("HierarchyManagementHierarchiesTree")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, { class: "p-m-2 p-d-flex p-flex-column hierarchy-scrollable-card" }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
        start: _withCtx(() => [
          _hoisted_1,
          _createVNode("span", null, _toDisplayString(_ctx.$t('managers.hierarchyManagement.hierarchiesSource')), 1)
        ]),
        _: 1
      })
    ]),
    content: _withCtx(() => [
      _createVNode("form", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_Calendar, {
            class: "kn-material-input",
            modelValue: _ctx.validityDate,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.validityDate = $event)),
            manualInput: true,
            showIcon: true,
            onDateSelect: _ctx.onValidityDateSelected
          }, null, 8, ["modelValue", "onDateSelect"])
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode("span", _hoisted_5, [
            _createVNode(_component_Dropdown, {
              class: "kn-material-input",
              modelValue: _ctx.selectedDimension,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedDimension = $event)),
              options: _ctx.dimensions,
              optionLabel: "DIMENSION_NM",
              onChange: _ctx.onSelectedDimensionChange
            }, null, 8, ["modelValue", "options", "onChange"]),
            _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('managers.hierarchyManagement.dimensions')), 1)
          ])
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("span", _hoisted_8, [
            _createVNode(_component_Dropdown, {
              class: "kn-material-input",
              modelValue: _ctx.hierarchyType,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.hierarchyType = $event)),
              options: _ctx.hierarchyManagementSourceCardDescriptor.hierarchyTypes,
              disabled: !_ctx.selectedDimension,
              onChange: _ctx.onHierarchyTypeSelected
            }, null, 8, ["modelValue", "options", "disabled", "onChange"]),
            _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('managers.hierarchyManagement.hierarchyType')), 1)
          ])
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode("span", _hoisted_11, [
            _createVNode(_component_Dropdown, {
              class: "kn-material-input",
              modelValue: _ctx.selectedHierarchy,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectedHierarchy = $event)),
              options: _ctx.hierarchies,
              optionLabel: "HIER_NM",
              disabled: !_ctx.hierarchyType,
              onChange: _ctx.onHierarchySelected
            }, null, 8, ["modelValue", "options", "disabled", "onChange"]),
            _createVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('managers.hierarchyManagement.hierarchies')), 1)
          ])
        ])
      ]),
      _createVNode(_component_HierarchyManagementHierarchiesFilterCard, {
        selectedHierarchy: _ctx.selectedHierarchy,
        onApplyFilters: _ctx.onApplyFilters
      }, null, 8, ["selectedHierarchy", "onApplyFilters"]),
      (_ctx.tree)
        ? (_openBlock(), _createBlock(_component_HierarchyManagementHierarchiesTree, {
            key: 0,
            propTree: _ctx.tree,
            nodeMetadata: _ctx.nodeMetadata,
            selectedDimension: _ctx.selectedDimension,
            selectedHierarchy: _ctx.selectedHierarchy,
            dimensionMetadata: _ctx.dimensionMetadata,
            treeMode: "info",
            onLoading: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('loading', $event)))
          }, null, 8, ["propTree", "nodeMetadata", "selectedDimension", "selectedHierarchy", "dimensionMetadata"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}